import * as React from "react";
import { FieldError } from "../ErrorMessage";
import * as cn from "classnames";
import { InterestMapping } from "@store";
import { PremiumFeatureIcon } from "../PremiumFeatureIcon";

export interface InterestTargetingComponentProps {
    value: string | null;
    onChange: (newValue: string | null) => void;
    field: any | null;
    // Other props here
    isDisabled: boolean;
    onCheckBoxAction: (fieldName: string, isRadio?: boolean) => void;
    interestsMapping: InterestMapping[];
}

export const InterestTargetingComponent = (props: InterestTargetingComponentProps) => (
    <>
        <div className="premium-block-wrapper interest-premium-block-wrapper">
            <label
                className="common-checkbox custom-interest-checkbox tour-campaign-interests-targeting"
                style={{ marginBottom: "1rem" }}
            >
                <input
                    type="checkbox"
                    name="Enable Interest Targeting"
                    value="interestTargeting"
                    id=""
                    checked={!props.isDisabled}
                    onChange={e => props.onCheckBoxAction(e.target.value, true)}
                />
                Enable Interest Targeting
                <span className="checkmark" />
            </label>
            <PremiumFeatureIcon status="trial" />
        </div>
        <div className={cn(props.field.visualState)}>
            {props.interestsMapping &&
                props.interestsMapping.map((interest, index) => (
                    <label
                        key={index}
                        className={cn(
                            "common-radio custom-interests-radio",
                            props.isDisabled ? "common-radio__isDisabled" : ""
                        )}
                    >
                        <input
                            type="radio"
                            name="interest targeting"
                            value={interest.type}
                            id=""
                            checked={props.value === interest.type}
                            onChange={() => props.onChange(interest.type)}
                            disabled={props.isDisabled}
                        />
                        <span className="device-targeting-icon ">
                            <img className="" src={interest.icon} />
                        </span>
                        <span className="checkmark" />
                        <span className="interests-title">{interest.type}</span>
                    </label>
                ))}
            <FieldError field={props.field} />
        </div>
    </>
);
